;(function() {
  'use strict'

  Controller.$inject = ["$stateParams", "actionService"];
  angular.module('app.action').controller('Action', Controller)

  /* @ngInject */
  function Controller($stateParams, actionService) {
    actionService.perform($stateParams.code)
  }
})()
